
<div class="flow-footer" :data-border="border">
	<slot />
</div>
